const SET_GLOBAL_SEARCH = 'common/SET_GLOBAL_SEARCH';
const SET_BREADCRUMB_REDIRECT_STATUS = 'common/SET_BREADCRUMB_REDIRECT_STATUS';

export {
    SET_GLOBAL_SEARCH,
    SET_BREADCRUMB_REDIRECT_STATUS,
};